<template>
  <div class="page">
    <!-- <loginModel/> -->
    <div class="page-content">
      <div class="category">
        <ul class="category-list">
          <li>
            <a href="javascript:;" @click="categoryNav" data-index="0" class="categorys active">热门</a>
          </li>
          <li>
            <a href="javascript:;" @click="categoryNav" data-index="1" class="categorys">最新</a>
          </li>
          <li>
            <a href="javascript:;" @click="categoryNav" data-index="2" class="categorys">热榜</a>
          </li>
        </ul>
      </div>
      <div class="content-box-list">
        <div class="content-box-item">
          <div class="info-box">
            <div class="meta-list">
              <ul>
                <li class="meta-item-post">
                  <a href="javascript:;">专栏</a>
                </li>
                <li class="meta-list-username">
                  <a href="javascript:;">用户名</a>
                </li>
                <li class="meta-list-time">
                  <a href="javascript:;">n小时前</a>
                </li>
                <li>
                  <a href="javascript:;">javascript</a>
                </li>
              </ul>
            </div>
            <div class="info-box-title">
              <a href="javascript:;">
                <h3>常见的十三个js面试题</h3>
              </a>
            </div>
            <div class="active-list">
              <a href="javascript:;">
                <img src="~@/assets/good.png" />
                <span>32</span>
              </a>
              <a href="javascript:;">
                <img src="~@/assets/msg.png" />
                <span>32</span>
              </a>
              <a href="javascript:;" class="zf">
                <img src="~@/assets/zf.png" />
              </a>
            </div>
          </div>
          <div class="info-img">
            <img src="~@/assets/ad.jpg" alt />
          </div>
        </div>
        <div class="content-box-item">
          <div class="info-box">
            <div class="meta-list">
              <ul>
                <li class="meta-item-post">
                  <a href="javascript:;">专栏</a>
                </li>
                <li class="meta-list-username">
                  <a href="javascript:;">用户名</a>
                </li>
                <li class="meta-list-time">
                  <a href="javascript:;">n小时前</a>
                </li>
                <li>
                  <a href="javascript:;">javascript</a>
                </li>
              </ul>
            </div>
            <div class="info-box-title">
              <a href="javascript:;">
                <h3>常见的十三个js面试题</h3>
              </a>
            </div>
            <div class="active-list">
              <a href="javascript:;">
                <img src="~@/assets/good.png" />
                <span>32</span>
              </a>
              <a href="javascript:;">
                <img src="~@/assets/msg.png" />
                <span>32</span>
              </a>
              <a href="javascript:;" class="zf">
                <img src="~@/assets/zf.png" />
              </a>
            </div>
          </div>
          <div class="info-img">
            <img src="~@/assets/ad.jpg" alt />
          </div>
        </div>
        <div class="content-box-item">
          <div class="info-box">
            <div class="meta-list">
              <ul>
                <li class="meta-item-post">
                  <a href="javascript:;">专栏</a>
                </li>
                <li class="meta-list-username">
                  <a href="javascript:;">用户名</a>
                </li>
                <li class="meta-list-time">
                  <a href="javascript:;">n小时前</a>
                </li>
                <li>
                  <a href="javascript:;">javascript</a>
                </li>
              </ul>
            </div>
            <div class="info-box-title">
              <a href="javascript:;">
                <h3>常见的十三个js面试题</h3>
              </a>
            </div>
            <div class="active-list">
              <a href="javascript:;">
                <img src="~@/assets/good.png" />
                <span>32</span>
              </a>
              <a href="javascript:;">
                <img src="~@/assets/msg.png" />
                <span>32</span>
              </a>
              <a href="javascript:;" class="zf">
                <img src="~@/assets/zf.png" />
              </a>
            </div>
          </div>
          <div class="info-img">
            <img src="~@/assets/ad.jpg" alt />
          </div>
        </div>
        <div class="content-box-item">
          <div class="info-box">
            <div class="meta-list">
              <ul>
                <li class="meta-item-post">
                  <a href="javascript:;">专栏</a>
                </li>
                <li class="meta-list-username">
                  <a href="javascript:;">用户名</a>
                </li>
                <li class="meta-list-time">
                  <a href="javascript:;">n小时前</a>
                </li>
                <li>
                  <a href="javascript:;">javascript</a>
                </li>
              </ul>
            </div>
            <div class="info-box-title">
              <a href="javascript:;">
                <h3>常见的十三个js面试题</h3>
              </a>
            </div>
            <div class="active-list">
              <a href="javascript:;">
                <img src="~@/assets/good.png" />
                <span>32</span>
              </a>
              <a href="javascript:;">
                <img src="~@/assets/msg.png" />
                <span>32</span>
              </a>
              <a href="javascript:;" class="zf">
                <img src="~@/assets/zf.png" />
              </a>
            </div>
          </div>
          <div class="info-img">
            <img src="~@/assets/ad.jpg" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="page-models">
      <div class="login-models showdow">
        <div class="login-models-title">掘金 - juejin.im</div>
        <div class="login-models-title-c">一个帮助开发者成长的社区</div>
        <form class="login-models-form">
          <input type="text" placeholder="用户名" />
          <input type="text" placeholder="手机号" />
          <input type="text" placeholder="密码（不少于6位）" />
          <button>立即注册</button>
        </form>
        <div class="thrid-login">
          <span>第三方登录:</span>
          <a href="javascript:;">
            <img src="~@/assets/xl.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/github.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/wx.png" alt />
          </a>
        </div>
      </div>
      <div class="ad-models showdow">
        <a href="javascript:;" class="ad-models-close">关闭</a>
        <a href="javascript:;">
          <img src="~@/assets/ad.jpg" alt />
        </a>
      </div>
      <div class="hot-tags-models showdow">
        <div class="hot-tags-models-title">
          <span>热门标签</span>
          <a href="javascript:;">查看更多</a>
        </div>
        <div class="hot-tags-list">
          <a href="javascript:;">架构</a>
          <a href="javascript:;">架构22</a>
          <a href="javascript:;">架构dfsdf</a>
          <a href="javascript:;">架构2342</a>
          <a href="javascript:;">架构d</a>
          <a href="javascript:;">架构sdfsd</a>
          <a href="javascript:;">架构ddd</a>
        </div>
      </div>
      <div class="author-models showdow">
        <div>
          <img src="~@/assets/WechatIMG3.jpeg" alt="no" />
        </div>
        <div>
          <div class="author">作者：Ragnar</div>
          <div class="intro">喜欢可以给个star~鼓励哦！</div>
        </div>
      </div>
      <div class="imgText-models showdow">
        <ul class="imgText-list">
          <li>
            <a href="javascript:;">
              <div>
                <img src="~@/assets/juejin-extension-icon.4b79fb4.png" alt />
              </div>
              <div>谷歌浏览器插件</div>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <div>
                <img src="~@/assets/collections.945b9ae.png" alt />
              </div>
              <div>收藏集</div>
            </a>
          </li>
        </ul>
      </div>

      <div class="about-us">
        <div>关于我们</div>
        <div class="account-list">
          <a href="javascript:;">
            <img src="~@/assets/wxx.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/jianshu.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/weibo.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/zhuanlan.png" alt />
          </a>
        </div>
        <div>
          ©2019 掘金
          <br />Powered by QingCloud
          <br />津ICP备15003202号-2
          <br />京公网安备11010802026719号
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginModel from "@/components/_basic-login-model.vue";
export default {
  data() {
    return {};
  },
  methods: {
    categoryNav: function(event) {
      let index = event.target.dataset.index;
      let list = document.getElementsByClassName("categorys");
      let num = list.length;
      for (let i = 0; i < num; i++) {
        list[i].className = "categorys";
      }
      list[index].className = "categorys active";
    }
  },
  components: {
    loginModel
  }
};
</script>

<style lang="less" scope>
@blue: #007fff;
@line: #f1f1f1;
@fontglay: #909090;
@size: 12px;
@zl: #b71ed7;

.showdow {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.active {
  color: @blue;
}



.page {
  display: flex;
  .page-content {
    flex: 1;
    background-color: #fff;
    transition: all 0.4s;
    min-height: 100vh;
    .category {
      line-height: 46px;
      padding-left: 20px;
      border-bottom: 1px solid @line;
      .category-list {
        display: inline-flex;
        li {
          position: relative;
          list-style: none;
          margin-right: 30px;
          &::after {
            position: absolute;
            content: "";
            height: 30%;
            width: 1px;
            top: 40%;
            right: -15px;
            background-color: @line;
          }
          &:last-child::after {
            content: none;
          }
          &:hover a {
            color: @blue;
          }
          a {
            color: @fontglay;
            font-size: @size;
          }
        }
      }
    }
    .content-box-list {
      min-width: 375px;
      .content-box-item {
        padding: 20px;
        border-bottom: 1px solid @line;
        display: flex;
        &:hover .info-box .active-list .zf {
          display: block;
        }
        .info-box {
          flex: 1;
          .meta-list {
            ul {
              list-style: none;
              display: flex;
              align-items: center;
              li {
                position: relative;
                padding-right: 10px;
                margin-right: 10px;
                &::after {
                  position: absolute;
                  content: "·";
                  right: -5px;
                  top: 1px;
                  color: @fontglay;
                }
                &:last-child::after {
                  content: none;
                }
                a {
                  color: @fontglay;
                  font-size: @size;
                  &:hover {
                    color: @blue;
                  }
                }
              }
              .meta-item-post {
                position: relative;
                a {
                  color: @zl;
                }
              }
            }
          }
          .info-box-title {
            a {
              color: #000;
              &:hover {
                text-decoration: underline;
              }
              h3 {
                margin: 6px 0 12px 0;
                font-size: 16px;
              }
            }
          }
          .active-list {
            display: flex;
            height: 27px;
            a {
              display: inline-flex;
              align-items: center;
              color: @fontglay;
              font-size: @size;
              padding: 4px;
              border: 1px solid @line;
              &:hover {
                background-color: #f7f8fa;
              }
              img {
                display: inline-block;
                width: 16px;
                height: 16px;
                margin-right: 4px;
              }
            }
            .zf {
              display: none;
            }
          }
        }
        .info-img {
          img {
            display: inline-block;
            height: 60px;
            width: 60px;
            border-radius: 4px;
          }
        }
      }
    }
  }
  .page-models {
    max-width: 240px;
    width: 240px;
    margin-left: 20px;
    .login-models {
      background-color: #fff;
      margin-bottom: 16px;
      padding: 16px;
      height: 260px;
      .login-models-title {
        font-weight: 600;
      }
      .login-models-title-c {
        font-size: 14px;
      }
      .login-models-form {
        margin-bottom: 14px;
        input {
          display: block;
          width: 100%;
          line-height: 36px;
          background-color: #fbfbfb;
          border: 1px solid #f4f4f4;
          border-radius: 2px;
          outline: none;
          margin: 10px 0;
          text-indent: 10px;
        }
        button {
          width: 100%;
          -webkit-appearance: none;
          appearance: none;
          background-color: #007fff;
          color: #fff;
          border-radius: 2px;
          border: none;
          padding: 0.5rem 1.3rem;
          outline: none;
          transition: background-color 0.3s, color 0.3s;
          cursor: pointer;
        }
      }
      .thrid-login {
        display: flex;
        align-items: center;
        span {
          font-size: 12px;
          color: #666;
          margin-right: 10px;
        }
        a {
          margin: 0 10px;
          img {
            display: inline-block;
            height: 20px;
            width: 20px;
          }
        }
      }
    }
    .ad-models {
      position: relative;
      height: 200px;
      overflow: hidden;
      margin-bottom: 16px;
      background-color: #fff;
      .ad-models-close {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #666;
        font-size: @size;
      }
      a {
        img {
          width: 100%;
        }
      }
    }
    .hot-tags-models {
      height: 244px;
      background-color: #fff;
      margin-bottom: 16px;
      .hot-tags-models-title {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        line-height: 45px;
        border-bottom: 1px solid @line;
        span {
          font-size: 14px;
        }
        a {
          font-size: @size;
          color: @blue;
        }
      }

      .hot-tags-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        padding: 15px;
        a {
          color: #000;
          font-size: @size;
          background-color: #f3f6f3;
          border-radius: 9999px;
          padding: 5px 20px;
          margin-right: 20px;
          margin-bottom: 15px;
          &:hover {
            background-color: #007fff;
            color: #fff;
          }
        }
      }
    }
    .author-models {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 82px;
      background-color: #fff;
      margin-bottom: 16px;
      img {
        display: inline-block;
        width: 60px;
      }
      .author {
        font-size: 14px;
        font-weight: 600px;
        margin-bottom: 3px;
      }
      .intro {
        font-size: 12px;
        color: #999;
      }
    }
    .imgText-models {
      background-color: #fff;
      margin-bottom: 16px;
      .imgText-list {
        list-style: none;
        li {
          padding: 0 20px;
          &:hover {
            background-color: #0080ff1e;
          }
          a {
            display: inline-flex;
            align-items: center;
            height: 60px;
            color: #000;
            img {
              width: 36px;
              margin-right: 20px;
            }
          }
        }
      }
    }
    .about-us {
      line-height: 24px;
      text-align: center;
      font-size: @size;
      color: #999;
      .account-list {
        a {
          img {
            width: 24px;
            margin: 5px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 724px) {
  .page-models {
    display: none;
  }

  .category {
    display: none;
  }
}
</style>
